<template>
  <div class="text-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="idAccion == 1"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Agregar servicio
        </v-btn>
      </template>
      <span>Agregar Servicio</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="idAccion == 2"
          icon 
          color="info" 
          class="px-0"
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <span>Editar Servicio</span>
    </v-tooltip>

    <v-dialog
      :name="'dialog_form_servicio_' + idCatServicio"
      :key="'dialog_form_servicio_' + idCatServicio"
      v-model="dialog"
      fullscreen
      hide-overlay 
      transition="dialog-bottom-transition"
    >
      <v-card>

        <v-toolbar dark color="primary" name="toolbar_dialog_form_servicio">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon color="white">{{ idAccion == 1 ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
            {{ idAccion == 1 ? 'Agregar Servicio' : 'Editar Servicio' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-form 
            class="mt-5 my-5"
            ref="form" 
            v-model="valid" 
            :lazy-validation="lazy"
          >
            <v-row>
              <v-col cols="12" md="8" class="px-8">
                <v-card
                  color="#A0935F"
                  dark
                  class="mb-4"
                >
                  <v-card-title class="headline">
                    <v-icon class="mr-2">mdi-information</v-icon> 
                    Información del servicio
                  </v-card-title>
                </v-card>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="nombreServicio"
                      :loading="loading"
                      label="Nombre del servicio *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      dense
                      required
                    ></v-text-field>  
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <select-campus :id-campus-prop="idCampus" :fn-change="setIdCampus" :requerido="true"></select-campus>
                  </v-col>
                  <v-col cols="12" md="4">
                    <select-division :id-campus="idCampus" :id-division-prop="idDivision" :fn-change="setIdDivision" :requerido="true"></select-division>
                  </v-col>
                  <v-col cols="12" md="4">
                    <select-dep-plan-unidad :id-campus="idCampus" :id-division="idDivision" :id-dep-plan-unidad-prop="idDepPlanUnidad" :fn-change="setIdDepPlanUnidad" :requerido="true"></select-dep-plan-unidad>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="nombreProceso"
                      :loading="loading"
                      label="Nombre del Proceso *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      dense
                      required
                    ></v-text-field>              
                  </v-col> 
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="claveProceso"
                      :loading="loading"
                      label="Clave del Proceso"
                      outlined
                      dense
                    ></v-text-field>              
                  </v-col>
                  <v-col cols="12" md="4">
                    <select-cat-clasificacion-proceso :desc-cat-clasificacion-proceso-prop="clasificacionProceso" :fn-change="setClasificacionProceso" :requerido="true"></select-cat-clasificacion-proceso>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-switch 
                      v-model="habilitado" 
                      class="mx-2" 
                      label="Habilitado" 
                      required  
                      style="justify-content: center; display: grid;  margin-top:5px;"
                      hide-details
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4" class="px-8">
                <v-card
                  color="#A0935F"
                  dark
                  class="mb-4"
                >
                  <v-card-title class="headline">
                    <v-icon class="mr-2">mdi-account-circle</v-icon> 
                    Información del Enlace
                  </v-card-title>
                </v-card>

                <v-row>
                  <v-col cols="12">
                    <buscador-empleado :fn-seleccionar-empleado="fnSeleccionarEmpleado" :ban-limpiar-datos="banLimpiarDatos" :hide-details="false"></buscador-empleado>
                  </v-col>
                </v-row>
                  
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="nombreEnlace"
                      :loading="loading"
                      label="Nombre"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="nueEnlace"
                      :loading="loading"
                      label="NUE *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      v-model="correoEnlace"
                      :loading="loading"
                      label="Correo Electrónico *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <small>* Campo obligatorio</small>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  large
                  color="success"
                  :disabled="!valid"
                  :loading="loadingSave"
                  @click="guardar"
                >
                <v-icon class="mr-2">mdi-floppy</v-icon>
                  guardar servicio
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      :name="'snackbar_dialog_form_servicio_' + idCatServicio"
      :key="'snackbar_dialog_form_servicio_' + idCatServicio"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { postServicio, putServicio } from "@/api";

export default {
  name: "DialogFormServicio",
  components: {
    SelectCampus: () => import("../comunes/SelectCampus"),
    SelectDivision: () => import("../comunes/SelectDivision"),
    SelectDepPlanUnidad: () => import("../comunes/SelectDepPlanUnidad"),
    SelectCatClasificacionProceso: () => import("../comunes/SelectCatClasificacionProceso"),
    BuscadorEmpleado: () => import("../comunes/BuscadorEmpleado"),
  },
  props: {
    idAccion: {
      type: Number,
      required: true
    },
    objServicio: {
      type: Object,
      default: function () {
        return {
          idCatServicio: 0,
          nombreServicio: '',
          idCampus: null,
          campus: null,
          idDivision: null,
          division: null,
          idDepPlanUnidad: null,
          depPlanUnidad: null,
          habilitado: false,
          clasificacionProceso: '',
          claveProceso: '',
          nombreProceso: '',
          nueEnlace: null,
          nombreEnlace: null,
          correoEnlace: null,
        }
      }
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingSave: false,

      valid: false,
      lazy: false,

      flagInitForm: 1,
      idAccionForm: 1,

      idCatServicio: 0,
      nombreServicio: '',
      idCampus: null,
      campus: null,
      idDivision: null,
      division: null,
      idDepPlanUnidad: null,
      depPlanUnidad: null,
      habilitado: false,
      clasificacionProceso: '',
      claveProceso: '',
      nombreProceso: '',
      nueEnlace: null,
      nombreEnlace: null,
      correoEnlace: null,     


      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

      banLimpiarDatos: 0,
    };
  },
  computed: {
  },
  watch:{
    dialog: {
      handler (newValue, oldValue) {
        if(this.$refs.form != undefined && newValue == true){
          this.$refs.form.resetValidation();
        }
        if(newValue == true){
          this.idCatServicio = this.objServicio.idCatServicio;
          this.nombreServicio = this.objServicio.nombreServicio;
          this.idCampus = this.objServicio.idCampus == null ? null : this.objServicio.idCampus.toString();
          this.campus = this.objServicio.campus;
          this.idDivision = this.objServicio.idDivision == null ? null : this.objServicio.idDivision.trim();
          this.division = this.objServicio.division;
          this.idDepPlanUnidad = this.objServicio.idDepPlanUnidad == null ? null : this.objServicio.idDepPlanUnidad.trim();
          this.depPlanUnidad = this.objServicio.depPlanUnidad;
          this.habilitado = this.objServicio.habilitado;
          this.clasificacionProceso = this.objServicio.clasificacionProceso;
          this.claveProceso = this.objServicio.claveProceso;
          this.nombreProceso = this.objServicio.nombreProceso;
          this.nueEnlace = this.objServicio.nueEnlace;
          this.nombreEnlace = this.objServicio.nombreEnlace;
          this.correoEnlace = this.objServicio.correoEnlace;
        }
        else{
          this.idCatServicio = 0;
          this.nombreServicio = '';
          this.idCampus = null;
          this.campus = null;
          this.idDivision = null;
          this.division = null;
          this.idDepPlanUnidad = null;
          this.depPlanUnidad = null;
          this.habilitado = null;
          this.clasificacionProceso = '';
          this.claveProceso = '';
          this.nombreProceso = '';
          this.nueEnlace = '';
          this.nombreEnlace = '';
          this.correoEnlace = '';
        }
			},
    }
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    async guardar(){
      var self = this;

      if (self.$refs.form.validate()) {

        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
            
        try {
          let response;

          var obj = {
            idCatServicio: this.idCatServicio,
            nombreServicio: this.nombreServicio,
            idCampus: this.idCampus,
            campus: this.campus,
            idDivision: this.idDivision,
            division: this.division,
            idDepPlanUnidad: this.idDepPlanUnidad,
            depPlanUnidad: this.depPlanUnidad,
            habilitado: this.habilitado,
            clasificacionProceso: this.clasificacionProceso,
            claveProceso: this.claveProceso,
            nombreProceso: this.nombreProceso,
            nueEnlace: this.nueEnlace,
            nombreEnlace: this.nombreEnlace,
            correoEnlace: this.correoEnlace
          }

          if(obj.idCatServicio == 0){
            response = await postServicio(obj);
          }
          else{
            response = await putServicio(obj);
          }

          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto") {
                self.snackbarTexto = "Servicio guardado con éxito";
                self.snackbarColor = "success";
                self.snackbar = true;

                self.fnOnSave();

                self.dialog = false;
              }
            } else {
              self.snackbarTexto = "DialogFormServicio: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "DialogFormServicio: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "DialogFormServicio: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    },
    fnSeleccionarEmpleado(objEmpleado){
      if(objEmpleado == undefined){
        this.nueEnlace = '';
        this.nombreEnlace = '';
        this.correoEnlace = '';
      }
      else{
        this.nueEnlace = objEmpleado.nue;
        this.nombreEnlace = objEmpleado.nombre;
        this.correoEnlace = objEmpleado.correo;
      }
    },
    setIdCampus(objCampus){
      this.idCampus = objCampus.id;
      this.campus = objCampus.descripcion;
    },
    setIdDivision(objDivision){
      this.idDivision = objDivision.id;
      this.division = objDivision.descripcion;
    },
    setIdDepPlanUnidad(objDepPlanUnidad){
      this.idDepPlanUnidad = objDepPlanUnidad.id;
      this.depPlanUnidad = objDepPlanUnidad.descripcion;
    },
    setClasificacionProceso(descClasifProceso){
      this.clasificacionProceso = descClasifProceso;
    },
  },  
};
</script>